import React, { PureComponent } from 'react'
import CSSModules from 'react-css-modules'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Link } from 'react-router-dom'

import DragPicker from 'components/picker/drag/drag_picker'
import MediaSearch from 'decorators/media_search/media_search_decorator'
import NearpodPickerOptions from 'components/nearpod_picker/components/options/nearpod_picker_options'
import { localize } from 'helpers/translator'
import VideoSearch from 'components/picker/search/video/video_picker_search'
import NearpodPickerBottomBar from 'components/nearpod_picker/components/bottom_bar/nearpod_picker_bottom_bar'
import { normalizeVideoSearchFiles } from 'helpers/pickerNormalizer'
import lessonTypes from 'helpers/enums/lessonTypes'

import LinkIcon from 'assets/components/nearpod_picker/link-icon.svg'

import styles from './nearpod_picker_interactive_video.scss'

class NearpodPickerInteractiveVideo extends PureComponent {

	cancelYoutubeSearch = () => {
		this.props.onMediaSearchClear('video')
	}

	saveYoutubeVideo = () => {
		const selectedItems = this.props.videoSearchResults.filter(
			(_, index) => this.props.videoSearchSelected.includes(index)
		)
		this.props.onFilesPicked(normalizeVideoSearchFiles(selectedItems, 'youtube'))
	}

	render() {
		return (
			<div styleName='wrapper'>
				{this.props.shouldShowYoutubeSearchBar &&
					<div styleName={classNames({
						'video-search': true,
						'video-search--full-height': this.props.videoSearchActive,
					})}>
						<VideoSearch
							placeholder={localize('picker_search_youtube_video_placeholder')}
							source='youtube'
							onSearchConfirm={this.props.onMediaSearchConfirm}
							onSearchChange={this.props.onMediaSearchChange}
							onNextPageRequest={this.props.onMediaSearchNextPageRequest}
							onSearchSelection={this.props.onMediaSearchSelection}
							searchTextValue={this.props.videoSearchTextValue}
							results={this.props.videoSearchResults}
							active={this.props.videoSearchActive}
							selected={this.props.videoSearchSelected}
							showMore={this.props.videoShowMore}
							message={this.props.videoMessage}
							title={this.props.videoTitle}
							hint={this.props.videoHint}
							multiselect={this.props.multiselect}
						/>
					</div>
				}
				{!this.props.videoSearchActive &&
					<div styleName='file-selection'>
						<div styleName='drag-and-drop'>
							<DragPicker
								onChange={this.props.onFilesPicked}
								accept={this.props.accept}
								pickerType={this.props.pickerType}
								dropRejectedHandler={this.props.onFileError}
								multiselect={this.props.multiselect}
							/>
						</div>
						<div>
							<span styleName='source-options-or'>{localize('picker_connector_or')}</span>
						</div>
						<NearpodPickerOptions
							onFilesPicked={this.props.onFilesPicked}
							onFileError={this.props.onFileError}
							multiselect={this.props.multiselect}
							accept={this.props.accept}
							googleDrivePickerOrigin={
								this.props.googleDrivePickerOrigin
							}
						/>
						<div styleName='source-options-premade'>
							<p styleName='source-options-premade-text'>{localize('interactive_video_creation_premade')}</p>
							<Link styleName='source-options-premade-link' to={`/t/search?t=${lessonTypes.VIDEO}`}>
								<span>{localize('interactive_video_creation_premade_link')}</span>
								<img styleName='source-options-premade-link-icon' src={LinkIcon} alt='Link Icon' />
							</Link>
						</div>
					</div>
				}
				{this.props.videoSearchActive &&
					<NearpodPickerBottomBar
						cancelText={localize('global_back')}
						saveHandler={this.saveYoutubeVideo}
						cancelHandler={this.cancelYoutubeSearch}
						shouldShowBackground={false}
						saveButtonEnabled={!!this.props.videoSearchSelected.length} />
				}
			</div>
		)
	}
}

NearpodPickerInteractiveVideo.defaultProps = {
	multiselect: true,
	googleDrivePickerOrigin: '',
}

NearpodPickerInteractiveVideo.propTypes = {
	onFilesPicked: PropTypes.func.isRequired,
	shouldShowYoutubeSearchBar: PropTypes.bool,
	onFileError: PropTypes.func.isRequired,
	multiselect: PropTypes.bool,
	accept: PropTypes.array.isRequired,
	pickerType: PropTypes.string.isRequired,
	googleDrivePickerOrigin: PropTypes.string,
	onSearchConfirm: PropTypes.func,
	onMediaSearchConfirm: PropTypes.func,
	onMediaSearchChange: PropTypes.func,
	onMediaSearchNextPageRequest: PropTypes.func,
	onMediaSearchSelection: PropTypes.func,
	videoSearchTextValue: PropTypes.string,
	videoSearchResults: PropTypes.array,
	videoSearchActive: PropTypes.bool,
	videoSearchSelected: PropTypes.array,
	videoShowMore: PropTypes.bool,
	videoMessage: PropTypes.string,
	videoTitle: PropTypes.string,
	videoHint: PropTypes.string,
	onMediaSearchClear: PropTypes.func.isRequired,
}

export default MediaSearch(
	CSSModules(NearpodPickerInteractiveVideo, styles, {allowMultiple: true})
)
